import React, { useState } from "react";
import { Link } from "react-router-dom";

// Sample blog posts array
// links --> youtube link
const blogPosts = [
  {
    Title: "Exploring the Future of AI in Everyday Life",
    information: [
      {
        id: 1,
        
        title: "Outlook Business Awards 2025",        
        image: "/assets/images/blog/s1.jpg",
        excerpt:
          "V S N Raju, Managing Director & CEO, Coempt Eduteck, for delivering a thought-leading theme address at the Enterprise & Leadership Awards 2025.",
        comments: 0,
        // links: "https://www.youtube.com/watch?v=bo217CuaiAE",
        links: "https://www.youtube.com/watch?v=4aFM-khAyO8",
      },
      {
        id: 2,
       
        title: "Coempt Presentation",
        
        image: "/assets/images/blog/s2.jpg",
        excerpt:
          "Coempt Edu Teck is a leading EdTech company with over 25 years of progressive experience in providing end-to-end examination solutions",
        comments: 0,
        // links: "https://www.youtube.com/watch?v=B0aes1oErLo",
        links: "https://www.youtube.com/watch?v=LgwXMu6oDYQ",
      },
      {
        id: 3,
       
        title: "Coempt Presentation",      
        image: "/assets/images/blog/s3.jpg",
        excerpt:
          "Coempt Edu Teck is a leading EdTech company with over 25 years of progressive experience in providing end-to-end examination solutions",
        comments: 0,
        // links: "https://www.youtube.com/watch?v=Vp7A9d_9YeY",
        links: "https://www.youtube.com/watch?v=bo217CuaiAE",
      },
    ],
  },
  // {
  //   Title: "Cloud Computing Innovations",
  //   information: [
  //     {
  //       id: 4,
  //       category: "Teck Insights",
  //       title: "Cloud Migration Strategies for Enterprises",
  //       date: "18 Dec",
  //       image: "/assets/images/blog/blog-image4.png",
  //       excerpt:
  //         "Best practices and strategies for successful cloud migration in enterprise environments.",
  //       comments: 3,
  //     },
  //     {
  //       id: 5,
  //       category: "Security",
  //       title: "Emerging Threats in Cybersecurity Landscape",
  //       date: "20 Dec",
  //       image: "/assets/images/blog/blog-image5.png",
  //       excerpt:
  //         "Understanding the latest cybersecurity threats and how to protect your organization.",
  //       comments: 5,
  //     },
  //     {
  //       id: 6,
  //       category: "Innovation",
  //       title: "IoT Transforming Industrial Operations",
  //       date: "22 Dec",
  //       image: "/assets/images/blog/blog-image6.png",
  //       excerpt:
  //         "How Internet of Things is revolutionizing industrial operations and manufacturing.",
  //       comments: 2,
  //     },
  //   ],
  // },
  // {
  //   Title: "Data Analytics Revolution",
  //   information: [
  //     {
  //       id: 7,
  //       category: "Analytics",
  //       title: "Big Data Analytics for Business Growth",
  //       date: "25 Dec",
  //       image: "/assets/images/blog/blog-image7.png",
  //       excerpt:
  //         "Leveraging big data analytics to drive business growth and make informed decisions.",
  //       comments: 7,
  //     },
  //     {
  //       id: 8,
  //       category: "Development",
  //       title: "Future of Mobile App Development",
  //       date: "28 Dec",
  //       image: "/assets/images/blog/blog-image8.png",
  //       excerpt:
  //         "Trends and technologies shaping the future of mobile application development.",
  //       comments: 4,
  //     },
  //     {
  //       id: 9,
  //       category: "Business",
  //       title: "Digital Transformation Roadmap for SMEs",
  //       date: "30 Dec",
  //       image: "/assets/images/blog/blog-image9.png",
  //       excerpt:
  //         "Comprehensive guide to digital transformation for small and medium enterprises.",
  //       comments: 6,
  //     },
  //   ],
  // },
];

const HomeBlog = () => {
  const [selectedTitle, setSelectedTitle] = useState(blogPosts[0].Title);

  const selectedPosts =
    blogPosts.find((post) => post.Title === selectedTitle)?.information || [];

  const displayedPosts = selectedPosts.slice(0, 3);

  return (
    <>
      <section className="mt-50 pb-80">
        <div className="container">
          {/* Section Header */}
          <div className="section-header text-center mb-20">
            {/* <h5
              className="wow fadeInUp d-flex align-items-center justify-content-center"
              data-wow-delay="00ms"
              data-wow-duration="1500ms"
            >
              <img
                className="me-2"
                src="/assets/images/icon/section-title.png"
                alt="icon"
                style={{ height: "20px", width: "40px" }}
              />
              <Link to="/gallery" className="text-decoration-none">
                <span style={{ fontSize: "2rem", color: "inherit" }}>
                  Gallery
                </span>
              </Link>
            </h5> */}
            <h2
              className="wow fadeInUp mt-3"
              data-wow-delay="200ms"
              data-wow-duration="1500ms"
            >
              Insights & Updates
            </h2>
            <p
              className="wow fadeInUp mt-2"
              data-wow-delay="400ms"
              data-wow-duration="1500ms"
            >
              Guides, tech insights, service-specific content, product updates,
              and integration tips
            </p>
          </div>

          {/* Horizontal Title Selection */}
          {/* <div className="wow fadeInUp" data-wow-delay="200ms">
            <div className="title-scroll-container">
              <div className="d-flex overflow-auto pb-3 hide-scrollbar">
                {blogPosts.map((post, index) => (
                  <button
                    key={index}
                    className={`me-3 px-3 py-2 rounded flex-shrink-0 ${
                      selectedTitle === post.Title
                        ? "text-white"
                        : "bg-transparent border border-dark text-dark"
                    }`}
                    style={
                      selectedTitle === post.Title
                        ? { backgroundColor: "#0a1530" }
                        : {}
                    }
                    onClick={() => setSelectedTitle(post.Title)}
                  >
                    {post.Title}
                  </button>
                ))}
              </div>
            </div>
          </div> */}

          {/* Blog Posts */}
          <div className="d-flex flex-wrap justify-content-center g-4">
            {displayedPosts.map((post, index) => (
              <div
                key={post.id}
                className="wow fadeInUp card-hover"
                style={{
                  flex: "0 0 calc(33.333% - 1.5rem)",
                  maxWidth: "calc(33.333% - 1.5rem)",
                  minWidth: "300px",
                  margin: "0.75rem",
                }}
                data-wow-delay={`${index * 200}ms`}
                data-wow-duration="1500ms"
              >
                <div className="blog__item blog__item--animated-border h-100 d-flex flex-column">
                  <div className="blog__image position-relative overflow-hidden">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="img-fluid w-100"
                    />

                    {/* YouTube Icon Overlay */}
                    <a
                      href={post.links}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="youtube-icon icon-hover"
                      style={{
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        transform: "translate(-50%, -50%)",
                        fontSize: "2rem",
                        color: "red",
                        background: "rgba(255, 255, 255, 0.63)",
                        borderRadius: "50%",
                        padding: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        // opacity: 0,
                        transition: "opacity 0.3s ease",
                        textDecoration: "none",
                        zIndex: 10,
                      }}
                    >
                      <i className="fa-brands fa-youtube"></i>
                    </a>

                    {/* Show icon on hover */}
                    <style>
                      {`
                        .blog__image:hover .youtube-icon {
                          opacity: 1;
                        }
                      `}
                    </style>

                    <div className="position-absolute top-0 start-0 p-2 w-50">
                      <div className="blog-tag bg-primary px-2 py-1 rounded w-100">
                        <span className="text-white small">
                          {post.category}
                        </span>
                      </div>
                    </div>
                    <div className="position-absolute top-0 end-0 p-2">
                      <div className="date-tag bg-dark bg-opacity-75 px-2 py-1 rounded">
                        <span className="text-white small">{post.date}</span>
                      </div>
                    </div>
                  </div>

                  <div className="blog__content p-3 d-flex flex-column flex-grow-1">
                    <ul className="blog-info d-flex justify-content-between pb-2 mb-3 border-bottom">
                      <li className="d-flex align-items-center">
                        
                      </li>
                      <li className="d-flex align-items-center">
                        
                      </li>
                    </ul>
                    <h3 className="fs-5 mb-3" style={{ color: "#0c0b09" }}>
                      <Link
                        to="/blog-details"
                        className="text-decoration-none text-dark primary-hover"
                      >
                        {post.title}
                      </Link>
                    </h3>
                    <p
                      className="mb-3 flex-grow-1"
                      style={{ fontSize: "16px" }}
                    >
                      {post.excerpt}
                    </p>
                    <Link
                      className="read-more-btn text-decoration-none d-inline-flex align-items-center"
                      to="/blog-details"
                    >
                      Read More{" "}
                      <i className="fa-regular fa-arrow-right-long ms-2" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* View All Button */}
          {/* <div className="text-center mt-5 wow fadeInUp" data-wow-delay="600ms">
            <Link to="/blog" className="main-btn btn btn-primary px-4 py-2">
              View All Resources
            </Link>
          </div> */}
        </div>
      </section>
    </>
  );
};

export default HomeBlog;
